import React from "react";
import { useNavigate, Link } from "react-router-dom";

const BackButton = ({ url }) => {
  const navigate = useNavigate();

  if (typeof url === "string") {
    const backUrl = url.split("/").slice(0, -1).join("/");
    return (
      <Link className="btn btn-secondary" to={backUrl}>
        <i className="fas fa-arrow-left"></i> Back
      </Link>
    );
  }

  return (
    <button className="btn btn-secondary" onClick={() => navigate(-1)}>
      <i className="fas fa-arrow-left"></i> Back
    </button>
  );
};

export default BackButton;
